import { useEffect, useState } from "react";
import { Flame, ExternalLink } from "lucide-react";
import { trendingHooks } from "@/lib/scoutApi";
import { daysAgo } from "./PostMeta";

const LANE_LABEL = { adversarial: "Adversarial", left: "Left", science: "Science", other: "Other" };

const when = (iso) => {
  const d = daysAgo(iso);
  return d === 0 ? "today" : d === 1 ? "yesterday" : `${d}d ago`;
};

const HookRow = ({ h }) => (
  <li data-testid="trending-hook" className="py-2.5 border-t border-slate-100 first:border-t-0">
    <div className="flex flex-wrap items-baseline gap-x-2 text-[10px] uppercase tracking-wider text-slate-400">
      <span className="text-[var(--accent)]">{LANE_LABEL[h.lane] || "—"}</span>
      <span className="text-[#0A192F] normal-case tracking-normal text-xs font-medium">{h.name}</span>
      <span>· {when(h.written_at)}</span>
      {h.is_fallback && <span className="text-amber-600 normal-case tracking-normal">field topic</span>}
    </div>
    <p className="mt-0.5 text-sm text-slate-700">
      {h.hook}
      {h.source_url && (
        <a href={h.source_url} target="_blank" rel="noopener noreferrer" data-testid="trending-hook-source" className="ml-1.5 inline-flex items-center gap-0.5 text-xs text-[var(--accent)] hover:text-[#0A192F] align-baseline">
          source <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </p>
  </li>
);

export const TrendingHooks = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    trendingHooks().then(setData).catch(() => setData({ hooks: [], days: 7 }));
  }, [refreshKey]);
  if (!data) return null;
  return (
    <aside data-testid="scout-trending" className="border border-slate-200 bg-slate-50/60 p-4 mb-8">
      <div className="flex items-center justify-between gap-2 mb-1">
        <div className="text-xs tracking-tight text-[var(--accent)] inline-flex items-center gap-2">
          <Flame className="w-3.5 h-3.5" /> What&apos;s hot this week
        </div>
        <span data-testid="scout-trending-count" className="text-[10px] uppercase tracking-wider text-slate-400">
          {data.hooks.length} hook{data.hooks.length === 1 ? "" : "s"} · last {data.days} days
        </span>
      </div>
      <p className="text-xs text-slate-500 mb-2">The news the post-writer anchored to across your featured voices. Newest first.</p>
      {data.hooks.length === 0 ? (
        <p data-testid="scout-trending-empty" className="text-sm text-slate-500 pt-2 border-t border-slate-200">
          No hooks yet — write posts for a featured voice and the news it found shows up here.
        </p>
      ) : (
        <ul className="max-h-72 overflow-y-auto pr-1">
          {data.hooks.map((h) => <HookRow key={`${h.candidate_id}-${h.written_at}`} h={h} />)}
        </ul>
      )}
    </aside>
  );
};

export default TrendingHooks;
